<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box">
          <div class="box-body">
            <v-server-table url="" :columns="columns" :options="options" name="persons" ref="persons"
                            @loading="toggleLoading" @loaded="toggleLoading" @row-click="showPerson">
              <template slot="fondi" slot-scope="props">
                <div>
                  <ul>
                    <li v-for="fund in props.row.fund.data">{{ fund.denominazione}}</li>
                  </ul>
                </div>
              </template>

              <template slot="actions" slot-scope="props">
                <div>
                  <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </template>
            </v-server-table>
          </div>
          <!-- /.box-body -->
          <div class="overlay" v-show="loading">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import personsApi from '../../api/persons'

  export default {
    data () {
      return {
        columns: [
          'nome', 'fondi', 'indirizzo', 'citta', 'actions'
        ],
        options: {
          sortable: [
            'nome', 'indirizzo', 'citta'
          ],
          requestFunction: function (query) {
            return personsApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Persone inserite',
        createButton: {
          display: true,
          text: 'Nuova persona',
          to: 'person'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          personsApi.delete(id)
            .then((response) => {
              this.$refs.persons.refresh()
              toastr.success('La persona è stata rimossa correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showPerson (row) {
        this.$router.push({name: 'personsShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
  tr {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/persons/Index.vue